import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Threesixseaterbus() {



  const cardData =
  {
    keyword: '36 Seater Bus on Rent in Pune',
    heading: 'Sanavi Travels: 36 Seater Bus on Rent in Pune',
    headingDescription: 'Sanavi Travels offers reliable 36 Seater Bus on Rent in Pune, providing safe, comfortable, and spacious transportation for large groups, corporate trips, school excursions, family outings, and outstation travel. Our fleet of well-maintained AC and non-AC 36-seater buses ensures ample seating, smooth rides, and a hassle-free journey for all passengers. With professional drivers, flexible full-day and outstation rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Pune including Hinjewadi, Baner, Wakad, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, making us a trusted choice for group transportation. Choose Sanavi Travels for trusted 36 seater bus rental services in Pune, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is Pune’s iconic 18th-century fort built by the Peshwas, featuring massive stone walls, grand gateways like Delhi Darwaza, and spacious courtyards. Though partly destroyed by fire, it stands as a symbol of Maratha heritage and valor. The evening light-and-sound show narrates Pune’s royal history."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a historic monument tied to India’s freedom movement, where Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned. It now houses a museum displaying Gandhi’s personal artifacts and documents amidst serene gardens, making it a significant heritage site."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered Ganesh temple. The idol, adorned with gold ornaments, draws thousands of devotees daily. Ganesh Chaturthi sees grand celebrations, music, and cultural events, highlighting its spiritual and social significance."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, situated on a hilltop near Pune, is famous for the 1670 battle where Tanaji Malusare sacrificed his life for Shivaji Maharaj. Visitors can trek or drive to explore the fort, enjoy scenic Sahyadri views, and savor local delicacies like pithla-bhakri."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from basalt rock, it features monolithic pillars and a serene sanctum. Despite its urban location, it offers peace, meditation, and a glimpse into ancient craftsmanship."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts including traditional ornaments, musical instruments, and household antiques. The recreated Mastani Mahal is a highlight, offering cultural and historical insights into India’s heritage."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views after climbing 103 steps. The hilltop temple complex, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era and includes smaller shrines and a museum."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global center for meditation, wellness therapies, and mindfulness. Spread across landscaped gardens, it attracts visitors seeking relaxation, rejuvenation, and spiritual growth."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. With arched bridges, water streams, and manicured lawns, it is perfect for morning walks, family outings, and photography."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot near Pune. Surrounded by hills, it offers scenic views, especially during monsoon. Visitors enjoy picnics, sunset views, and local snacks, making it a favorite weekend destination."
  }
]
,



"services": [
  {
    "name": "36 Seater Bus on Rent in Pune",
    "description": "36 Seater Bus on Rent in Pune provides spacious and comfortable transport for medium to large groups, ideal for family trips, corporate travel, weddings, school excursions, and tourist outings. Fully air-conditioned buses feature reclining seats, ample legroom, and luggage space to ensure a smooth and relaxed journey. Experienced chauffeurs manage traffic, routes, and timing, guaranteeing punctual and safe travel. Flexible pickup, drop-off, and multi-stop itineraries make this service perfect for city travel, day trips, weekend getaways, and outstation trips from Pune."
  },
  {
    "name": "36 Seater Bus Hire Pune",
    "description": "36 Seater Bus Hire Pune offers organized and reliable rental services for group travel, including family outings, corporate events, weddings, school tours, and sightseeing trips. These buses are fully air-conditioned with comfortable seating and luggage capacity. Professional drivers ensure safe, timely, and smooth travel. Flexible and customizable itineraries with multiple stops make this service ideal for day trips, weekend getaways, and long-distance travel from Pune."
  },
  {
    "name": "AC 36 Seater Bus Pune",
    "description": "AC 36 Seater Bus Pune ensures a cool and comfortable travel experience with fully air-conditioned interiors, spacious seating, and wide legroom. Perfect for corporate travel, family trips, school excursions, weddings, and leisure tours, this service emphasizes safety, comfort, and convenience. Experienced chauffeurs handle navigation, traffic, and timing, allowing passengers to relax throughout the journey with flexible pickup, drop-off, and route options."
  },
  {
    "name": "Luxury 36 Seater Bus Pune",
    "description": "Luxury 36 Seater Bus Pune provides a premium travel experience with stylish interiors, air-conditioning, comfortable seats, and modern amenities. Ideal for VIP transport, corporate trips, weddings, and exclusive group tours, this service combines comfort, elegance, and punctuality. Professional chauffeurs manage traffic, routes, and schedules efficiently to ensure a smooth and safe journey. Customizable itineraries and flexible pickup and drop-off locations make it suitable for city and outstation travel from Pune."
  },
  {
    "name": "Wedding 36 Seater Bus Pune",
    "description": "Wedding 36 Seater Bus Pune specializes in transporting wedding guests safely and comfortably. Fully air-conditioned with spacious seating and luggage storage, these buses provide a stress-free travel experience for weddings, receptions, and related ceremonies. Professional chauffeurs ensure punctual arrivals, smooth driving, and coordinated multi-stop travel for family weddings, destination weddings, and large celebrations from Pune."
  },
  {
    "name": "Corporate 36 Seater Bus Pune",
    "description": "Corporate 36 Seater Bus Pune provides reliable transportation for business groups, corporate events, employee transfers, conferences, and corporate tours. Fully air-conditioned with comfortable seating and ample luggage space, these buses offer a safe and stress-free journey. Experienced chauffeurs manage routes, traffic, and timing efficiently. Flexible scheduling, multi-stop trips, and convenient pickup and drop-off locations make it ideal for short or long-distance corporate travel from Pune."
  },
  {
    "name": "Outstation 36 Seater Bus Pune",
    "description": "Outstation 36 Seater Bus Pune is designed for long-distance group travel. Air-conditioned and spacious with reclining seats and luggage space, these buses provide comfortable rides for family trips, corporate tours, school excursions, and tourist travel. Professional drivers handle highways, traffic, and route planning, ensuring safe and timely arrivals. Flexible itineraries with multiple stops allow smooth travel outside Pune."
  },
  {
    "name": "Affordable 36 Seater Bus Pune",
    "description": "Affordable 36 Seater Bus Pune offers budget-friendly travel for family trips, corporate outings, school tours, weddings, and group excursions without compromising comfort or safety. Fully air-conditioned buses with spacious seating and luggage space provide a reliable and smooth travel experience. Experienced chauffeurs manage navigation, traffic, and schedules efficiently. Flexible pickup, drop-off, and customized routes make it perfect for day trips, weekend getaways, and outstation journeys from Pune."
  },
  {
    "name": "Chauffeur Driven 36 Seater Bus",
    "description": "Chauffeur Driven 36 Seater Bus provides a stress-free travel experience with professional drivers handling routes, traffic, and timing. Fully air-conditioned with comfortable seats and ample luggage space, these buses are suitable for family trips, corporate travel, weddings, school excursions, and leisure tours. Passengers can relax and enjoy a safe, smooth, and convenient journey."
  },
  {
    "name": "Best 36 Seater Bus Pune",
    "description": "Best 36 Seater Bus Pune delivers high-quality, reliable, and comfortable transportation for medium to large groups. Air-conditioned with spacious seating and luggage capacity, these buses are ideal for weddings, corporate events, family trips, school excursions, and tourist tours. Professional chauffeurs ensure safe driving, punctual pickups, and smooth travel. Flexible itineraries, multi-stop options, and customizable routes make it perfect for city and outstation travel from Pune."
  },
  {
    "name": "Pune Bus Booking Service",
    "description": "Pune Bus Booking Service allows customers to easily reserve 36-seater buses for family trips, corporate travel, weddings, school excursions, and group tours. With fully air-conditioned buses, comfortable seating, and luggage space, these buses ensure safe, smooth, and convenient travel. Flexible booking options, multi-stop trips, and customizable itineraries make planning medium to large group travel in and around Pune simple and efficient."
  },
  {
    "name": "Tourist 36 Seater Bus Pune",
    "description": "Tourist 36 Seater Bus Pune offers organized and comfortable transport for sightseeing, city tours, heritage visits, and leisure trips for medium to large groups. Fully air-conditioned with spacious seating and luggage space, these buses provide a relaxing travel experience. Experienced chauffeurs manage traffic, routes, and stops efficiently, allowing passengers to enjoy stress-free sightseeing. Suitable for families, corporate groups, school trips, and friends exploring Pune and nearby destinations."
  },
  {
    "name": "Event Bus Rental Pune",
    "description": "Event Bus Rental Pune provides dependable and comfortable transportation for weddings, corporate gatherings, parties, and other social events. Fully air-conditioned with spacious seating and luggage storage, these buses ensure a smooth and enjoyable travel experience. Professional chauffeurs manage punctual pickups, safe driving, and multi-stop itineraries. Ideal for medium to large groups attending events in Pune and surrounding areas."
  },
  {
    "name": "Family Trip Bus Pune",
    "description": "Family Trip Bus Pune is perfect for medium to large family outings, weekend trips, vacation travel, and leisure excursions. Fully air-conditioned 36-seater buses with spacious seating and luggage space provide comfort and convenience. Experienced chauffeurs handle traffic, route planning, and timing for a safe, smooth journey. Flexible pickup, drop-off, and multi-stop itineraries make it ideal for day trips, weekend getaways, and multi-day family travel from Pune."
  },
  {
    "name": "Group Travel Bus Pune",
    "description": "Group Travel Bus Pune specializes in transporting medium to large groups for family outings, corporate trips, school excursions, weddings, and social events. Fully air-conditioned with comfortable seating and ample luggage space, these buses provide a smooth and reliable travel experience. Experienced chauffeurs manage safe driving, routes, and schedules. Flexible pickup, drop-off, and multi-stop itineraries make it convenient for group travel within Pune and nearby areas."
  }
],
"tableData": [
  ["36 Seater Bus on Rent in Pune", "36 Seater Bus Hire Pune"],
  ["AC 36 Seater Bus Pune", "Luxury 36 Seater Bus Pune"],
  ["Wedding 36 Seater Bus Pune", "Corporate 36 Seater Bus Pune"],
  ["Outstation 36 Seater Bus Pune", "Affordable 36 Seater Bus Pune"],
  ["Chauffeur Driven 36 Seater Bus", "Best 36 Seater Bus Pune"],
  ["Pune Bus Booking Service", "Tourist 36 Seater Bus Pune"],
  ["Event Bus Rental Pune", "Family Trip Bus Pune"],
  ["Group Travel Bus Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "36 Seater Bus on Rent in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers 36-seater buses on rent in Pune, perfect for medium to large group trips, corporate events, school excursions, and family outings."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Travel in air-conditioned, clean, and regularly serviced 36-seater buses, ensuring a comfortable and enjoyable journey in Pune."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with Pune routes, ensuring safe and timely transportation for medium and large groups."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides upfront pricing for 36-seater bus rentals, including fuel, tolls, and driver allowances, with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, route planning, and any last-minute changes for your 36-seater bus rental."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half-day, full-day, or customized rental packages based on your group’s schedule and travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All 36-seater buses are thoroughly cleaned and sanitized before each trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for 36-seater bus rentals in Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide 36-seater buses on rent in Pune?',
    answer: 'Yes, Sanavi Travels offers 36-seater buses for medium to large group trips, corporate events, school excursions, and family outings in Pune.'
  },
  {
    question: 'How can I book a 36-seater bus in Pune?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'Are the 36-seater buses well-maintained and air-conditioned?',
    answer: 'Yes, all our 36-seater buses are clean, air-conditioned, and regularly serviced for a comfortable travel experience.'
  },
  {
    question: 'Are drivers experienced with Pune routes?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Pune routes to ensure safe and timely transportation.'
  },
  {
    question: 'Can I rent the 36-seater bus for a few hours or a full day?',
    answer: 'Absolutely. We offer hourly, half-day, full-day, and custom packages to meet your travel requirements.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all 36-seater buses are thoroughly cleaned and sanitized before departure.'
  },
  {
    question: 'Is customer support available during the rental?',
    answer: 'Yes, our 24x7 customer support team is available throughout your 36-seater bus rental.'
  },
  {
    question: 'What payment options are available for 36-seater bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is punctual service guaranteed for 36-seater bus rentals?',
    answer: 'Yes, Sanavi Travels ensures on-time pickups and reliable service for all 36-seater bus bookings in Pune.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Pawar',
    feedback: 'Booked a 36-seater bus for our corporate outing. Spacious, comfortable, and the driver was very professional.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Kavita Joshi',
    feedback: 'Excellent 36-seater bus rental service. Smooth ride, clean vehicle, and punctual service from Sanavi Travels.',
    rating: 5
  }
];





































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "36 Seater Bus on Rent in Pune - Sanavi Travels",
  "description": "Hire 36 seater buses in Pune with Sanavi Travels. AC and luxury buses ideal for weddings, corporate events, outstation trips, family travel, group tours, events, and chauffeur-driven comfortable journeys.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};






  return (
    <div>

<Helmet>
  <title>
    36 Seater Bus on Rent in Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book AC and luxury 36 seater buses in Pune with Sanavi Travels. Perfect for weddings, corporate events, outstation trips, family travel, group tours, events, and safe chauffeur-driven journeys."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/82.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Threesixseaterbus;